import 'reflect-metadata';
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { HelmetProvider } from 'react-helmet-async';
import { authService } from './services/AuthService'
import { PartnerProvider } from './contexts/partnerContext';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Failed to find the root element');
}


try {
  await authService.init();
  
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <HelmetProvider>
        <PartnerProvider>
            <App />
        </PartnerProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
} catch (error) {
  console.error("Keycloak initialization failed", error);
}

